/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom"
import Breadcrumb from "../Breadcrumb";
import Card from "../Card";
import FormInput from "../FormInput";
import LoadingAlert from "../LoadingAlert";
import { qreq } from "../../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { SidebarGlobal } from "../_SidebarGlobal";
import MessageDialog from "../MessageDialog";
import React from "react";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import AppActions from "../AppActions";
import L from "../Lang";
import Alert from "../Alert";

class InstanceView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {
                subjectLabel: 'Subject',
                specimenLabel: 'Specimen',
                useDefaultDB: true,
                isMain: true
            },
            itemDefaults: {
                subjectLabel: 'Subject',
                specimenLabel: 'Specimen',
                useDefaultDB: true,
                isMain: true
            }
        };

        this.submitRef = React.createRef();
    }

    async componentDidMount() {
        await this.getSettings();
        this.load();
        SidebarGlobal.setSubNav(<>
            <button type="button" className="btn btn-primary" onClick={() => this.submitRef.current.click()}>
                <Icon icon="faSave" /> <L><L>Save</L></L>
            </button>
        </>);

    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        this.setState({ loading: true });
        if (this.props.params.id) {
            try {
                const j = await qreq.getAsync('/api/instance/get/' + this.props.params.id);
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item)
                    this.setState({ item: j.item });
            }
            catch (e) {
                this.unkownErrorCallback(e);
                this.goBack();
            }
        }
        else
            this.setState({ item: { ...this.state.itemDefaults }, loading: false });

        this.setState({ loading: false });
    }


    submit = async (e) => {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };


        this.setState({ saving: true });

        try {
            const j = await qreq.postAsync('/api/instance/save', { ...item });
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else {
                this.success('Created!');
                this.goBack();
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        this.setState({ saving: false });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Instance</L></h1><LoadingAlert /></div>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Instance</L></h1>
                <Breadcrumb path={[['Instances', '/instance'], [this.props.params.id ? 'Edit' : 'New']]} />
                {this.state.item && <div className="row">
                    <div className="col-lg-12">
                        <Card title="Instance Info">
                            <FormInput model={this.state.item} name="name" label="Instance Name" type="text" required onChange={this.change} />
                            <FormInput model={this.state.item} name="ident" label="Domain" type="text" required onChange={this.change} />
                            <FormInput model={this.state.item} name="dbName" label="Database Name" type="text" required onChange={this.change} />
                            <FormInput model={this.state.item} name="instanceModel" label="Instance Type" type="select" required
                                options={[
                                    { id: 'GEN', name: 'Company Hub' },
                                    { id: 'WMS', name: 'Electronic Health Record' },
                                    { id: 'LIS', name: 'Laboratory Information System' },
                                    { id: 'MNF', name: 'Medical Device Logistics' }
                                ]} onChange={this.change}
                            />
                            <FormInput model={this.state.item} name="subjectLabel" label="Subject Label" type="text" required onChange={this.change}
                                placeholder={this.state.publicSettings?.subjectLabel} />
                            <FormInput model={this.state.item} name="specimenLabel" label="Specimen Label" type="text" required onChange={this.change}
                                placeholder={this.state.publicSettings?.specimenLabel} />
                            <FormInput model={this.state.item} name="isMain" label="Main Instance (Runs Worker Services)" type="switch" onChange={this.change}
                                defaultValue={this.state.item.isMain} disabled />
                            <FormInput model={this.state.item} name="useDefaultDB" label="Use Default Database Host" type="switch" onChange={this.change}
                                defaultValue={this.state.item.useDefaultDB} disabled />
                        </Card>
                    </div>
                </div>}
                <AppActions>
                    <button ref={this.submitRef} type="submit" className="btn btn-success btn-lg" disabled={this.state.saving}>
                        <Icon icon="faSave" /> <L><L>Save</L></L>
                    </button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(InstanceView);